module.exports = __webpack_public_path__ + "static/media/portfolio-05 copy.0a3172e9.jpg";